import React, { Component } from "react";
import {
  HelpBlock,
  FormGroup,
  FormControl,
  ControlLabel
} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import "./Signup.css";
import axios from 'axios';
import ReactGA from 'react-ga';
import config from "../config";


const base64 = require('base-64');

export default class Signup extends Component {
  constructor(props) {
    super(props);

    this.initializeReactGA();

    this.state = {
      isLoading: false,
      email: "",
      password: "",
      confirmPassword: "",
      confirmationCode: "",
      newUser: null,
      duplicateEmail: false,
      passwordError: false
    };
  }

  initializeReactGA() {
    ReactGA.initialize('UA-136595020-1');
    ReactGA.pageview('/Signup');
  }

  validateForm() {
    return (
      this.state.email.length > 0 &&
      this.state.password.length > 0 &&
      this.state.password === this.state.confirmPassword
    );
  }

  validateConfirmationForm() {
    return this.state.confirmationCode.length > 0;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleSubmit = event => {
    event.preventDefault();

    this.setState({ isLoading: true });

      axios.post(config.API_HOST + '/user/create',
                 {email: this.state.email,
                  password: this.state.password })
      .then(res => {
        // Put response data in the console for now during dev
        console.log(res);

        // Check if user email was already taken
        if (res.data.error_code === "duplicate_email") {
          this.setState({ duplicateEmail: true });
          this.setState({ isLoading: false });

        } else if (res.data.error_code === "password_error") {
          this.setState({ passwordError: true });
          this.setState({ isLoading: false });
        } else {
          const newUser = {
            username: this.state.email,
            password: this.state.password
          };
          this.setState({
            newUser
          });
          this.setState({ isLoading: false });
        }
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }



  handleConfirmationSubmit = event => {
    event.preventDefault();

    this.setState({ isLoading: true });

      axios.post(config.API_HOST + '/user/verify',
                 {email: this.state.email,
                  confirmation_code: this.state.confirmationCode})
      .then(res => {
        // Put response data in the console for now during dev
        console.log(res);

        // store User info
        this.props.setUserId(res.data.user_id);
        this.props.setUserAuth(base64.encode(this.state.email + ":" + this.state.password));
        this.props.userHasAuthenticated(true);
        this.props.history.push("/");
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }


  renderConfirmationForm() {
    return (
      <form onSubmit={this.handleConfirmationSubmit}>
        <FormGroup controlId="confirmationCode" bsSize="large">
          <ControlLabel>Confirmation Code</ControlLabel>
          <FormControl
            autoFocus
            type="tel"
            value={this.state.confirmationCode}
            onChange={this.handleChange}
          />
          <HelpBlock>Please check your email for the code.</HelpBlock>
        </FormGroup>
        <LoaderButton
          block
          bsSize="large"
          disabled={!this.validateConfirmationForm()}
          type="submit"
          isLoading={this.state.isLoading}
          text="Verify"
          loadingText="Verifying…"
        />
      </form>
    );
  }

  renderForm() {
    return (
      <form onSubmit={this.handleSubmit}>

      <h2> Sign up for Free </h2>

      {this.state.duplicateEmail
            ? <p> Sorry, we already have a user with that email... </p>
            : <div />}

      {this.state.passwordError
            ? <p> Sorry, please select a different password... </p>
            : <div />}

        <FormGroup controlId="email" bsSize="large">
          <ControlLabel>Email</ControlLabel>
          <FormControl
            autoFocus
            type="email"
            value={this.state.email}
            onChange={this.handleChange}
          />
        </FormGroup>
        <FormGroup controlId="password" bsSize="large">
          <ControlLabel>Password</ControlLabel>
          <FormControl
            value={this.state.password}
            onChange={this.handleChange}
            type="password"
          />
        </FormGroup>
        <FormGroup controlId="confirmPassword" bsSize="large">
          <ControlLabel>Confirm Password</ControlLabel>
          <FormControl
            value={this.state.confirmPassword}
            onChange={this.handleChange}
            type="password"
          />
        </FormGroup>
        <LoaderButton
          block
          bsSize="large"
          disabled={!this.validateForm()}
          type="submit"
          isLoading={this.state.isLoading}
          text="Signup"
          loadingText="Signing up…"
        />
      </form>
    );
  }

  render() {
    return (
      <div className="Signup">
        {this.state.newUser === null
          ? this.renderForm()
          : this.renderConfirmationForm()}
      </div>
    );
  }
}
